import request from '../../axios';

export const getSubBrandDetails = async (subBrandGuid?: string) => {
  const {data}: {data: ISubBrand} = await request.get(
    `/api/v2/warehouse/sub-brand-detail/${subBrandGuid}`,
  );

  return data;
};
